import React, { Component } from 'react';
import PropTypes from 'prop-types';
import animateScrollTo from 'animated-scroll-to';
import InputMask from 'react-input-mask';
import exact from 'prop-types-exact';
import Select from 'react-select';

class ContactFormComponent extends Component {
    constructor(props) {
        super(props);

        this.state = {
            email: '',
            name: '',
            tel: '',
            city: '',
            state: '',
            text: '',
            categoryId: '0',
            touched: {
                email: false,
                name: false,
                tel: false,
                text: false,
                categoryId: false,
            },
        };
    }

    componentDidMount() {
        animateScrollTo(0, { speed: 700 });

        if (this.props.subject) {
            // set the categoryId to the given subject.
            if (this.props.subject === 'comercial') {
                // Currently only comercial is supported
                this.setState((prevState) => ({
                    categoryId: '2',
                    text: 'Quero saber mais sobre as possibilidades de ser um parceiro da Antena 1 e receber o mídia kit.',
                    touched: {
                        ...prevState,
                        categoryId: true,
                        text: true,
                    },
                }));
            } else {
                // eslint-disable-next-line no-console
                console.error('unsuported subject given to ContactFormComponent: ', this.props.subject);
            }
        }
    }

    handleEmailChange = (evt) => {
        evt.persist();

        this.setState((prevState) => {
            const tempTouched = prevState.touched;

            tempTouched.email = true;

            return {
                email: evt.target.value,
                touched: tempTouched,
            };
        });
    }

    handleNameChange = (evt) => {
        evt.persist();

        this.setState((prevState) => {
            const tempTouched = prevState.touched;

            tempTouched.name = true;

            return {
                name: evt.target.value,
                touched: tempTouched,
            };
        });
    }

    handleTelChange = (evt) => {
        evt.persist();

        this.setState((prevState) => {
            const tempTouched = prevState.touched;

            tempTouched.tel = true;

            return {
                tel: evt.target.value,
                touched: tempTouched,
            };
        });
    }

    handleCityChange = (evt) => {
        evt.persist();

        this.setState((prevState) => {
            const tempTouched = prevState.touched;

            tempTouched.city = true;

            return {
                city: evt.target.value,
                touched: tempTouched,
            };
        });
    }

    handleStateChange = (evt) => {
        evt.persist();

        this.setState((prevState) => {
            const tempTouched = prevState.touched;

            tempTouched.state = true;

            return {
                state: evt.target.value,
                touched: tempTouched,
            };
        });
    }

    handleTextChange = (evt) => {
        evt.persist();

        this.setState((prevState) => {
            const tempTouched = prevState.touched;

            tempTouched.text = true;

            return {
                text: evt.target.value,
                touched: tempTouched,
            };
        });
    }

    handleCategoryChange = (selectedOption) => {
        this.setState((prevState) => ({
            categoryId: selectedOption ? selectedOption.value : '',
            touched: {
                ...prevState.touched,
                categoryId: true,
            },
        }));
    }

    handleSubmit = (evt) => {
        evt.preventDefault();

        if (!this.canBeSubmitted()) {
            return;
        }

        const { email, name, tel, city, state, text, categoryId } = this.state;
        const { userId } = this.props;
        const data = {
            name,
            email,
            tel,
            city,
            state,
            text,
            categoryId,
            userId,
        };

        this.props.sendMessage(data);
    }

    _validate = function _validate(email, name, tel, city, state, text) {
        const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        const nameRegex = /^[a-z\u00C0-\u017F\s ]+$/i;

        const emailValid = email.match(emailRegex) != null && email.length <= 50;
        const nameValid = name.match(nameRegex) != null && name.length >= 3 && name.length <= 30;
        const telValid = tel.length === 0 || (tel.length >= 13 && tel.length <= 15);
        const cityValid = city.length === 0 || (city.length >= 3 && city.length <= 30);
        const stateValid = state.length === 0 || state.length === 2;
        const textValid = text.length >= 3 && text.length <= 1000;

        // returning validation ERRORS!
        return {
            email: !emailValid,
            text: !textValid,
            tel: !telValid,
            city: !cityValid,
            state: !stateValid,
            name: !nameValid,
        };
    }

    canBeSubmitted() {
        const errors = this._validate(this.state.email, this.state.name, this.state.tel, this.state.city, this.state.state, this.state.text);
        const isDisabled = Object.keys(errors).some((x) => errors[x]) || this.state.categoryId === '0';

        return !isDisabled;
    }

    render() {
        const errors = this._validate(this.state.email, this.state.name, this.state.tel, this.state.city, this.state.state, this.state.text);
        const isDisabled = Object.keys(errors).some((x) => errors[x]) || this.props.submitting || this.state.categoryId === '0';
        let emailRed = this.state.touched.email;

        if (emailRed) {
            emailRed = errors.email;
        }

        let nameRed = this.state.touched.name;

        if (nameRed) {
            nameRed = errors.name;
        }

        let telRed = this.state.touched.tel;

        if (telRed) {
            telRed = errors.tel;
        }

        let cityRed = this.state.touched.city;

        if (cityRed) {
            cityRed = errors.city;
        }

        let stateRed = this.state.touched.state;

        if (stateRed) {
            stateRed = errors.state;
        }

        let textRed = this.state.touched.text;

        if (textRed) {
            textRed = errors.text;
        }

        let categoryIdRed = this.state.touched.categoryId;

        if (categoryIdRed) {
            categoryIdRed = this.state.categoryId === '0';
        }

        const optionsSelect = [
            {
                value: '1',
                label: 'Geral',
            },
            {
                value: '2',
                label: 'Comercial',
            },
            {
                value: '3',
                label: 'RH',
            },
            {
                value: '4',
                label: 'Promoções',
            },
            {
                value: '5',
                label: 'Relatar um problema',
            },
            {
                value: '6',
                label: 'Jornalismo',
            },
            {
                value: '7',
                label: 'Programação musical',
            },
        ]

        // Geral  - 1
        // Comercial - 2
        // RH - 3
        // Promoções - 4
        // Relatar um Problema - 5
        // Jornalismo - 6
        // Programação Musical - 7
        // Assinatura - 8


        // @TODO uncomment the following, once the assiantura is live
        /* <option value="8">Assinatura</option> */


        const customStyles = {
            control: (base) => ({
                ...base,
                borderRadius: 0,
                borderColor: '#aaa',
                boxShadow: 'none',
                '&:hover': {
                    borderColor: '#aaa',
                },
            }),
            indicatorSeparator: () => ({
                display: 'none',
            }),
            menu: (base) => ({
                ...base,
                borderRadius: '8px',
                backgroundColor: '#fff',
                boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
            }),
            option: (base, { isFocused, isSelected }) => ({
                ...base,
                backgroundColor: isSelected ? '#F2F4F7' : isFocused ? '#F2F4F7' : '#fff',
                color: '#000',
                padding: '10px',
            }),
        };

        return (
            <form className="contactForm" onSubmit={this.handleSubmit}>

                <div className="tw-justify-center tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-mx-auto">
                    <div className="inputGroup tw-flex tw-flex-col tw-m-4">
                        <label htmlFor="msgName">Nome</label>
                        <input
                            className={nameRed ? 'error contactFormInput' : 'contactFormInput'}
                            type="text"
                            value={this.state.name}
                            onChange={this.handleNameChange}
                            maxLength="30"
                            name="msgName"
                            autoComplete="name"
                            id="msgName"
                            disabled={this.props.submitted}
                            autoCapitalize="words"
                        />
                    </div>

                    <div className="inputGroup tw-flex tw-flex-col tw-m-4">
                        <label htmlFor="msgTel">Telefone</label>
                        <InputMask
                            mask="(99) 99999-9999"
                            placeholder="(00) 00000-0000"
                            maskChar={null}
                            className={telRed ? 'error contactFormInput' : 'contactFormInput'}
                            name="msgTel"
                            type="tel"
                            autoComplete="tel"
                            value={this.state.tel}
                            onChange={this.handleTelChange}
                            id="msgTel"
                            disabled={this.props.submitted}
                        />
                    </div>
                </div>
                <div className="tw-justify-center tw-m-auto tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-mx-auto">
                    <div className="inputGroup tw-flex tw-flex-col tw-m-4">
                        <label htmlFor="msgEmail">E-mail</label>
                        <input
                            className={emailRed ? 'error contactFormInput' : 'contactFormInput'}
                            name="msgEmail"
                            type="text"
                            autoComplete="email"
                            value={this.state.email}
                            onChange={this.handleEmailChange}
                            id="msgEmail"
                            disabled={this.props.submitted}
                            autoCapitalize="off"
                            autoCorrect="off"
                        />
                    </div>

                    <div className="tw-flex tw-flex-col tw-m-4">
                        <label htmlFor="msgSubject">Assunto</label>
                        <Select
                            id="msgSubject"
                            instanceId="msgSubject"
                            placeholder="Selecione o assunto"
                            className={categoryIdRed ? 'error' : ''}
                            onChange={this.handleCategoryChange}
                            value={optionsSelect.find((option) => option.value === this.state.categoryId)}
                            isSearchable={false}
                            styles={customStyles}
                            options={optionsSelect}
                        />
                    </div>
                </div>
                <div className="tw-justify-center tw-m-auto tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-mx-auto">
                    <div className="inputGroup tw-flex tw-flex-col tw-m-4">
                        <label htmlFor="msgCity">Cidade</label>
                        <input
                            className={cityRed ? 'error contactFormInput' : 'contactFormInput'}
                            type="text"
                            value={this.state.city}
                            onChange={this.handleCityChange}
                            maxLength="30"
                            name="msgCity"
                            autoComplete="city"
                            id="msgCity"
                            disabled={this.props.submitted}
                            autoCapitalize="words"
                        />
                    </div>

                    <div className="inputGroup tw-flex tw-flex-col tw-m-4">
                        <label htmlFor="msgState">Estado</label>
                        <input
                            className={stateRed ? 'error contactFormInput' : 'contactFormInput'}
                            type="text"
                            value={this.state.state}
                            onChange={this.handleStateChange}
                            maxLength="2"
                            name="msgState"
                            autoComplete="state"
                            id="msgState"
                            disabled={this.props.submitted}
                        />
                    </div>
                </div>
                <div className="tw-justify-center tw-m-auto tw-grid tw-grid-cols-1 md:tw-grid-cols-1 tw-mx-auto tw-px-4">
                    <label htmlFor="msgTx">Mensagem</label>
                    <textarea
                        autoComplete="off"
                        className={textRed ? 'error contactFormInputArea' : 'contactFormInputArea'}
                        value={this.state.text}
                        onChange={this.handleTextChange}
                        name="msgTx"
                        id="msgTx"
                        disabled={this.props.submitted}
                        autoCapitalize="sentences"
                    />
                </div>

                <p>Preencha todos os campos para enviar sua mensagem.</p>
                <button
                    type="submit"
                    className={isDisabled ? 'submitButtonDisabled' : 'submitButtonEnabled'}
                    disabled={isDisabled}
                >
                    Enviar
                </button>
            </form>
        );
    }
}

ContactFormComponent.propTypes = exact({
    sendMessage: PropTypes.func.isRequired,
    submitting: PropTypes.bool.isRequired,
    submitted: PropTypes.bool.isRequired,
    userId: PropTypes.number,
    subject: PropTypes.string,
});

export default ContactFormComponent;
